
    export default function HTMLMarker(lat,lng){
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            console.error('Google Maps API non è ancora caricata')
            return
        }

        this.lat = lat;
        this.lng = lng;
        this.pos = new google.maps.LatLng(lat,lng);
    }
    